import { LocalizedTotalPrice, YadoHotel, YadoRoom } from "../types";

const baseUrl = '/snow/api/v1/'

export const fetchHotels = async (query): Promise<YadoHotel[]> => {
  try {
    const searchParams = new URLSearchParams(query).toString();
    const response = await fetch(`${baseUrl}stay_packages/hotels?${searchParams}`);

    if (!response.ok) {
      throw new Error('fetchHotels failed');
    }

    const responseJson = await response.json();
    return responseJson.yado_hotels as YadoHotel[];
  } catch (error) {
    console.error(error);
    return [] as YadoHotel[];
  }
};

export const fetchHotelsWithoutDate = async (query): Promise<YadoHotel[]> => {
  try {
    const searchParams = new URLSearchParams(query).toString();
    const response = await fetch(`${baseUrl}stay_packages/hotels_without_date?${searchParams}`);

    if (!response.ok) {
      throw new Error('fetchHotels failed');
    }

    const responseJson = await response.json();
    return responseJson.yado_hotels as YadoHotel[];
  } catch (error) {
    console.error(error);
    return [] as YadoHotel[];
  }
};


export const fetchHotelRooms = async (yadoId: string, query): Promise<YadoRoom[]> => {
    try {
    const searchParams = new URLSearchParams(query).toString();
    const response = await fetch(`${baseUrl}stay_packages/hotels/${yadoId}/rooms?${searchParams}`);

    if (!response.ok) {
      throw new Error('fetchHotelRooms failed');
    }

    const responseJson = await response.json();
    return responseJson.yado_rooms as YadoRoom[];
  } catch (error) {
    console.error(error);
    return [] as  YadoRoom[];
  }
};

export const fetchRoomPriceCalendar = async (yadoId: string, query): Promise<{ date: string, price: LocalizedTotalPrice }[]> => {
  const searchParams = new URLSearchParams(query).toString();
  const response = await fetch(`${baseUrl}stay_packages/hotels/${yadoId}/rooms/calendar?${searchParams}`).then((data) => {
    return data.json();
  }).catch((error) => {
    console.error(error);
    return { calendar: {} };
  })
  return response.calendar;
};
